"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SessionServiceLive = void 0;
const HttpProvider_1 = require("../utils/HttpProvider");
const sessionIdStorage_1 = require("../utils/sessionIdStorage");
class SessionServiceLive {
    setCurrentSessionId(sessionId, rememberMe = false) {
        (0, sessionIdStorage_1.setCurrentSessionId)(sessionId, rememberMe);
    }
    getCurrentSessionId() {
        return (0, sessionIdStorage_1.getCurrentSessionId)();
    }
    removeCurrentSessionId() {
        (0, sessionIdStorage_1.removeCurrentSessionId)();
    }
    async createSession(params) {
        const { userId } = params;
        const response = await HttpProvider_1.httpProvider.post("session/create-session", {
            userId,
            rememberMe: params.rememberMe ?? false,
        });
        this.setCurrentSessionId(response.data.payload.sessionId, params.rememberMe ?? false);
        return response.data;
    }
    async revokeSession(reason) {
        // Sent with no body when the caller gives no reason, so an explicit sign-out keeps
        // the request shape it has always had and the server-side default still applies.
        const response = reason
            ? await HttpProvider_1.httpProvider.post("session/revoke-session", { reason })
            : await HttpProvider_1.httpProvider.post("session/revoke-session");
        this.removeCurrentSessionId();
        return response.data;
    }
    async updateLastAccess(lastAccess) {
        const response = await HttpProvider_1.httpProvider.patch("session/update-session", {
            lastActive: lastAccess,
        });
        return response.data;
    }
}
exports.SessionServiceLive = SessionServiceLive;
//# sourceMappingURL=SessionServiceLive.js.map